export const BASE_URL = '/panel';

export const ENROLLMENTS_COURSES_ROUTE = {
  key: 'COURSES',
  path: '',
};

export const ENROLLMENTS_BOOTCAMPS_ROUTE = {
  key: 'BOOTCAMPS',
  path: 'bootcamp/',
};

export const ENROLLMENTS_DEGREES_ROUTE = {
  key: 'DEGREES',
  path: 'microdegree/',
};

export const ENROLLMENTS_ACADEMIES_ROUTE = {
  key: 'ACADEMIES',
  path: 'academias/',
};

export const ENROLLMENTS_TRACKS_ROUTE = {
  key: 'TRACKS',
  path: 'especializaciones/',
};

export const ENROLLMENTS_CAREERS_ROUTE = {
  key: 'CAREERS',
  path: 'carreras/',
};

export const ENROLLMENTS_BUNDLES_ROUTE = {
  key: 'BUNDLES',
  path: 'certificaciones/',
};

export const ENROLLMENTS_ROUTES = [
  ENROLLMENTS_COURSES_ROUTE,
  ENROLLMENTS_DEGREES_ROUTE,
  ENROLLMENTS_ACADEMIES_ROUTE,
  ENROLLMENTS_TRACKS_ROUTE,
  ENROLLMENTS_BOOTCAMPS_ROUTE,
  ENROLLMENTS_CAREERS_ROUTE,
  ENROLLMENTS_BUNDLES_ROUTE,
];

export const ENROLLMENTS_ROUTE_PATH = '/mis-cursos/';
export const CLASSNOTES_ROUTE_PATH = '/mis-apuntes/';
export const PROJECTS_ROUTE_PATH = '/mis-proyectos/';
export const DIPLOMAS_ROUTE_PATH = '/mis-diplomas/';
export const STUDY_PLAN_ROUTE_PATH = '/mi-plan-de-estudios/';
export const SAVED_COURSES_ROUTE_PATH = '/mis-cursos-guardados/';
